//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'scan',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};